import React from 'react'
import { countries } from '../../../../utilities/content/supportedCountries'

// import yn from 'yn'

export const CountrySelectField = ({ input, name, label, size, options, event, required, meta: { touched, error } }) => {
  let selectOptions = []

  for (let country in countries) {
    let countryCode = countries[country].alpha2Code

    // if (yn(process.env.REACT_APP_COMPONENT_ENABLE_COUNTRY_CODE_GEO)) {
    //   countryCode = countries[country].geoCode
    // }

    selectOptions.push(
      <option
        key={ countryCode }
        value={ countryCode }
      >
        { countries[country].name }
      </option>
    )
  }

  return (
    <div className={touched && error ? 'u-form-col u-form-col--error u-form-col--' + size : 'u-form-col u-form-col--' + size}>
      <label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>
        { required ? '*' : null }
        { label }
      </label>
      <select
        { ...input }
        className='u-form-select'
        // onChange={ e => { countryState( e ) } }
        // value={ defaultValue }
        aria-labelledby={ input.name + 'Label' }
        required={required}
        aria-required={required ? true : false}
      >
        <option value="0" disabled>--</option>
        { selectOptions }
      </select>
      { touched && ((error && <p className="u-font-error" aria-live="assertive">{error}</p>)) }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/forms/guestForm/elements/CountrySelectField.js